import { Box, MantineSize } from '@mantine/core';
import { ReactNode } from 'react';

interface SettingRowProps {
  children: ReactNode;
  noBorder?: boolean;
  py?: MantineSize | number;
}

export const SettingRow = ({ children, noBorder = false, py = 14 }: SettingRowProps) => {
  return (
    <Box py={py} style={{ borderBottom: noBorder ? 'none' : '1px solid #F0F0F5' }}>
      {children}
    </Box>
  );
};
